import { useEffect } from 'react';
import { useBookingContext } from '@/contexts/BookingContext';

/**
 * Hook to sync template state with booking context
 * This allows the management actions to access selected date/time
 */
export const useBookingStateSync = (
  selectedDate: Date | null,
  selectedTime: string | null
) => {
  // Get booking context for state sync (optional - only if BookingProvider exists)
  let setSelectedDate = () => {};
  let setSelectedTime = () => {};
  
  try {
    const bookingContext = useBookingContext();
    setSelectedDate = bookingContext.setSelectedDate;
    setSelectedTime = bookingContext.setSelectedTime;
  } catch (error) {
    // BookingProvider not found - this is fine for preview/edit pages
    // Use no-op functions
  }

  // Sync template state to context
  useEffect(() => {
    setSelectedDate(selectedDate);
  }, [selectedDate, setSelectedDate]);

  useEffect(() => {
    setSelectedTime(selectedTime);
  }, [selectedTime, setSelectedTime]);
};
